export default __webpack_public_path__ + "static/N0063-27ac094877221b9188fcf9bdf0fe4b4c.png";